//@flow

import styled from 'styled-components';
import { Field, Form, ErrorMessage } from 'formik';
import { LinkButton } from 'styles/Buttons';

export const ContainerView = styled.div`
  padding: ${props => (props.paddingView ? props.paddingView : '57px')} 0;
`;

export const ContainerLogo = styled.div`
  margin: auto;
  width: 50%;
  padding: 0 10px;
`;

export const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 15px;
`;

export const StyledForm = styled(Form)`
  text-align: center;
  color: #333;
`;

export const StyledInput = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
`;

export const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
  position: absolute;
  top: 35px;
  font-size: ${props => (props.fontSize ? props.fontSize : '14')}px;
`;

export const AdvisorLogo = styled.div.attrs({
  style: ({ url }) => ({
    backgroundImage: `url('${url}')`
  })
})`
  height: 81px;
  width: auto;
  background-size: contain;
  background-repeat: no-repeat;
  margin: 0 auto ${props => (props.padBottom ? props.padBottom : '35px')};
`;

export const ContainerLink = styled.div`
  margin: 18px auto 0;
  text-align: center;
`;

export const StyledLinkButton = styled(LinkButton)`
  color: ${props => (props.color ? props.color : '#E1701D')};
  font-size: 13px;
  font-weight: 500;
  line-height: 15px;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: ${props => (props.color ? props.color : '#9d4e14')};
    opacity: 0.5;
  }
`;
